module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sagitta/sge_vis-1b636efe61d60902091b5539cd8d430b.jpg";